import React from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useGoogleSSO } from './hooks/useGoogleSSO';
import { useSelector } from 'react-redux';
import { UserData } from './model/User';
import { AxiosResponse } from 'axios';
import { ApplicationState } from 'store/store';
import { Throbber } from 'lib/Throbber';

interface GoogleSSOProps {
    onSignInSuccess: (data: UserData) => void;
    onSignInError: (error: AxiosResponse<{ message: string; code: string }>) => void;
    onStart?: () => void;
}

export const GoogleSSO: React.FC<React.PropsWithChildren<GoogleSSOProps>> = ({
    onSignInSuccess,
    onSignInError,
    onStart
}) => {
    const { settings } = useSelector((state: ApplicationState) => state.settings);

    const { googleSSOId, container, loading } = useGoogleSSO(onSignInSuccess, onSignInError, onStart);
    if (!settings?.googleSSOEnabled) {
        return null;
    }
    return (
        <Grid ref={container} size={12}>
            <Box display="flex" justifyContent="center">
                <div id={googleSSOId} />
            </Box>
            {loading && <Throbber isFullScreen text="" />}
        </Grid>
    );
};
